import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('contact');
    if (target) {
      const offsetTop = target.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">Lakshaya Sivabalan</h1>
          <p className="hero-subtitle">Chartered Professional Accountant</p>
          <p className="hero-description">
            Providing expert financial guidance and accounting services to individuals and businesses 
            for over 15 years. Your trusted partner in financial success.
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary" onClick={handleContactClick}>
              Get Consultation
            </a>
            {/* <a href="/resume.pdf" download className="btn btn-secondary">
             <i className="fas fa-download"></i> Download Resume 
            </a>*/}
          </div>
        </div>
        <div className="hero-image">
          <img 
            src="https://pixabay.com/get/ga8933ebb3c4f960c4d5c97a464bd5ad353a960eef18cc0c4551d9045424d7099a81665f64271c895d1b75579148dfa5b8d365c9d440d596bbfa24127f82aa52c_1280.jpg" 
            alt="Professional accountant office" 
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;